import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=e04b38da&"
import script from "./Profile.vue?vue&type=script&lang=js&"
export * from "./Profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e04b38da')) {
      api.createRecord('e04b38da', component.options)
    } else {
      api.reload('e04b38da', component.options)
    }
    module.hot.accept("./Profile.vue?vue&type=template&id=e04b38da&", function () {
      api.rerender('e04b38da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/users/Profile.vue"
export default component.exports